<template>
  <div class="gmb-attribute-item group" v-if="attribute">
    <div class="attribute-name">
      {{ attribute.displayName }}
    </div>
    <div class="chip-group">
      <GmbAttributeChip
        v-for="item in attribute.options"
        :key="item.name"
        :name="item.displayName"
        :value="item.name === selectedValue || null"
        :boolean-only="true"
        :delete-mode="deleteMode"
        @input="selectValue($event ? item.name : null)"
      ></GmbAttributeChip>
    </div>
  </div>
</template>

<script>
import GmbAttributeItem from "@/components/FacilityDetails/GmbAttributes/GmbAttributeItem.vue";

export default {
  name: "GmbAttributeItemEnum",
  extends: GmbAttributeItem
};
</script>
